const slugs = {
  // private
  dashboard: '/dashboard',
  overview: '/overview',
  overviewTwo: '/overview/two',
  overviewThree: '/overview/three',
  tickets: '/tickets',
  ideas: '/ideas',
  ideasTwo: '/ideas/two',
  ideasThree: '/ideas/three',
  contacts: '/contacts',
  agents: '/agents',
  articles: '/articles',
  settings: '/settings',
  subscription: '/subscription',
  // auth
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot_password',
  sd: '/sd',
  candidate: '/candidate',
  totalcandidate: '/totalcandidates',
  jobOpenings: '/job-openings',
  jobApplications: '/job-applications',
  interviewProgress: '/interviewprogress/:applicant_name',
  sheduled: '/scheduledcandidates',
  rejected: '/rejectedcandidates',
  progress: '/progresscandidates',
  selected: '/selectedcandidates',
  employees: '/employees',
  createemp: '/createemployee',
  onboarding: '/onboarding',
  employeesWithoutSalary: '/employees/without-salary',
  leaveTracker: '/leave-tracker',
  leaves: '/leaves',
  payroll: '/payroll',
  payrollProcess: '/payroll/process',
  payrollSlip: '/payroll/slip',
  bulkSalary: '/payroll/bulk-salary',
  payslipLogs: '/payroll/logs',
  detailedSalaryReport: '/payroll/detailed-salary-report',
  // Form 16
  payrollForm16: '/payroll/form16',
  payrollForm16Detail: '/payroll/form16/:id',
  payrollDeclarationsAdmin: '/payroll/form16/declarations',
  payrollRectifications: '/payroll/form16/rectifications',
  payrollEmployerSetup: '/payroll/form16/employer',
  // Employee Form 16
  empDeclarations: '/declarations',
  empForm16: '/form16',
  empForm16Detail: '/form16/:id',
  empRectify: '/form16/rectify',
  // Tax Calculator
  taxCalculator: '/tax-calculator',
  masterData: '/master-data',
  organizationChart: '/organization/chart',
  teamLeaves: '/team-leaves',
  attendancePresent: '/attendance/present',
  shiftManagement: '/attendance/shift-management',
  biometricManagement: '/attendance/biometric',
  userRoleMgmt: '/settings/roles',
  companyProfile: '/settings/company-profile',
  activityLogs: '/settings/activity-logs',
};

export default slugs;
